export default "__VITE_ASSET__DfJY5EbL__"